module.exports = "/static/assets/e71dba2ccaa69d866c3a022104e7bfad.png";